import React, { useState } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqData = [
  {
    question: "What is HackerThread?",
    answer:
      "HackerThread is a platform that provides information about data breaches and leaked information. We offer services to help individuals and organizations understand their exposure in various data leaks.",
  },
  {
    question: "How do I search for my information?",
    answer:
      "You can search for your information by entering your email address in the search bar on the dashboard. Our system will then check if your email appears in any known data breaches.",
  },
  {
    question: "Is my search data kept confidential?",
    answer:
      "Yes, we take your privacy seriously. All searches are encrypted and we do not store or share your search queries with third parties.",
  },
  {
    question: "What should I do if I find my information in a breach?",
    answer:
      "If you find your information in a breach, we recommend changing your passwords immediately, enabling two-factor authentication where possible, and monitoring your accounts for any suspicious activity.",
  },
  {
    question: "How often is your database updated?",
    answer:
      "We update our database regularly with new breach information as it becomes available. However, the frequency can vary depending on when new breaches are discovered and reported.",
  },
  // Add more FAQ items here, up to 10 total
];

function FAQ() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Box sx={{ flexGrow: 1, my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Frequently Asked Questions
        </Typography>
        <Box sx={{ mt: 4, height: "60vh", overflowY: "auto" }}>
          {faqData.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography variant="h6">{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Container>
  );
}

export default FAQ;
